export default "__VITE_ASSET__hf_pNG80__"